import apiClient from './client';

export interface UserPublic {
  id: string;
  display_name: string;
  username?: string;
  location?: string;
  connection_type?: string;
  last_seen: string;
  sharing_enabled: boolean;
  is_online: boolean;
  friend_code?: string;
  is_supporter: boolean;
}

export interface FriendSummary {
  friendship_id: string;
  friend: UserPublic;
  auto_approve_connections: boolean;
  bandwidth_limit_mbps?: number;
  daily_data_limit_gb?: number;
  accepted_at?: string;
}

export interface FriendRequestEntry {
  request_id: string;
  friend: UserPublic;
  created_at: string;
}

export interface FriendRequestsResponse {
  sent: FriendRequestEntry[];
  received: FriendRequestEntry[];
}

export interface QRCodeResponse {
  friend_code: string;
  qr_code_data: string;
}

export interface AcceptFriendRequestWithLimits {
  auto_approve_connections?: boolean;
  bandwidth_limit_mbps?: number;
  daily_data_limit_gb?: number;
}

export interface UpdateFriendshipLimits {
  auto_approve_connections?: boolean;
  bandwidth_limit_mbps?: number | null;
  daily_data_limit_gb?: number | null;
}

export const friendsApi = {
  getFriends: () =>
    apiClient.get<FriendSummary[]>('/api/v1/friends/'),

  addFriendByCode: (friend_code: string) =>
    apiClient.post<FriendRequestEntry>('/api/v1/friends/add-by-code', { friend_code }),

  getFriendRequests: () =>
    apiClient.get<FriendRequestsResponse>('/api/v1/friends/requests'),

  acceptFriendRequest: (request_id: string, limits?: AcceptFriendRequestWithLimits) =>
    apiClient.post<FriendSummary>(`/api/v1/friends/requests/${request_id}/accept`, limits || {}),

  declineFriendRequest: (request_id: string) =>
    apiClient.post<{ message: string }>(`/api/v1/friends/requests/${request_id}/decline`),

  removeFriend: (friendship_id: string) =>
    apiClient.delete<{ message: string }>(`/api/v1/friends/${friendship_id}`),

  updateFriendLimits: (friendship_id: string, limits: UpdateFriendshipLimits) =>
    apiClient.put<FriendSummary>(`/api/v1/friends/${friendship_id}/limits`, limits),

  getQRCode: () =>
    apiClient.get<QRCodeResponse>('/api/v1/friends/qr-code'),
};